var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMetalDeckLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #e6e6e6;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #f5f5f5;\r\n      }\r\n\r\n      .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\r\n        stroke: #000;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke-width: 0.22px;\r\n      }\r\n\r\n      .cls-5 {\r\n        stroke-width: 0.67px;\r\n      }\r\n\r\n      .cls-6 {\r\n        stroke-width: 0.33px;\r\n      }\r\n\r\n      .cls-7 {\r\n        stroke-width: 0.47px;\r\n      }\r\n\r\n      .cls-8 {\r\n        stroke-width: 0.8px;\r\n      }\r\n\r\n      .cls-9 {\r\n        font-size: 8.79px;\r\n        font-family: ArialMT, Arial;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IconMetalDeckLayer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boundary"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 256,
    height: 200
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Metal_Deck",
    "data-name": "Metal Deck"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "78.36 99.88 78.43 99.68 73.56 93.27 69.13 91.68 64.26 94.57 58.94 92.66 58.87 92.87 64.33 94.83 69.2 91.94 73.49 93.48 78.36 99.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "64.26 94.57 69.2 91.64 82.35 84.27 74.65 83.86 58.94 92.66 64.26 94.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "64.33 94.83 69.38 92 69.2 91.94 66.61 93.48 64.33 94.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "78.43 99.68 103.88 85.42 96.57 80.38 73.56 93.27 78.36 99.58 78.43 99.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "73.56 93.27 96.57 80.38 89.93 80.03 69.13 91.68 73.56 93.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "97.85 106.9 97.92 106.69 93.05 100.29 88.62 98.69 83.75 101.59 78.43 99.68 78.36 99.88 83.82 101.85 88.69 98.95 92.98 100.5 97.85 106.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "83.75 101.59 88.69 98.65 111.58 85.83 103.88 85.42 78.43 99.68 79.33 100 83.75 101.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "83.82 101.85 88.87 99.02 88.69 98.95 86.93 100 83.82 101.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "97.92 106.69 133.12 86.98 125.81 81.94 93.05 100.29 97.85 106.6 97.92 106.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "93.05 100.29 125.81 81.94 119.16 81.58 88.62 98.69 92.25 100 93.05 100.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "117.34 113.92 117.42 113.71 112.54 107.31 108.11 105.71 103.24 108.61 97.92 106.69 97.85 106.9 103.31 108.86 108.18 105.97 112.47 107.51 117.34 113.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "103.24 108.61 108.18 105.67 140.82 87.39 133.12 86.98 97.92 106.69 103.24 108.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "103.31 108.86 108.36 106.03 108.18 105.97 105.59 107.51 103.31 108.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "117.42 113.71 162.35 88.53 155.05 83.49 112.54 107.31 117.34 113.61 117.42 113.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "112.54 107.31 155.05 83.49 148.4 83.14 108.11 105.71 112.54 107.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.83 120.93 136.91 120.73 132.03 114.32 127.6 112.73 122.73 115.62 117.42 113.71 117.34 113.92 122.8 115.88 127.68 112.98 131.96 114.53 136.83 120.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "122.73 115.62 128 112.5 170.06 88.94 162.35 88.53 117.42 113.71 122.73 115.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "122.8 115.88 127.86 113.05 127.68 112.98 125.08 114.53 122.8 115.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.83 120.93 191.48 90.32 191.59 90.09 136.91 120.73 136.83 120.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.91 120.73 191.59 90.09 184.28 85.05 132.03 114.32 136.91 120.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "132.03 114.32 184.28 85.05 177.63 84.7 127.6 112.73 128 112.87 132.03 114.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "191.59 78.7 209.78 68.51 131.74 40.41 74.54 72.46 128 75.31 191.59 78.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "191.59 89.86 191.59 78.7 74.54 72.46 74.54 83.62 82.72 84.06 89.93 80.03 96.57 80.38 103.52 85.17 111.96 85.62 119.16 81.58 125.81 81.94 132.75 86.72 141.2 87.17 148.4 83.14 155.05 83.49 161.99 88.28 170.43 88.73 177.63 84.7 184.28 85.05 191.23 89.84 191.59 89.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.26,
    y1: 94.57,
    x2: 58.94,
    y2: 92.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 58.94,
    y1: 92.66,
    x2: 58.87,
    y2: 92.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 58.87,
    y1: 92.87,
    x2: 64.33,
    y2: 94.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.33,
    y1: 94.83,
    x2: 69.2,
    y2: 91.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 69.2,
    y1: 91.94,
    x2: 73.49,
    y2: 93.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 73.49,
    y1: 93.48,
    x2: 78.36,
    y2: 99.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 78.36,
    y1: 99.88,
    x2: 78.43,
    y2: 99.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 78.43,
    y1: 99.68,
    x2: 73.56,
    y2: 93.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 73.56,
    y1: 93.27,
    x2: 69.13,
    y2: 91.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 69.13,
    y1: 91.68,
    x2: 64.26,
    y2: 94.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 82.35,
    y1: 84.27,
    x2: 74.65,
    y2: 83.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 74.65,
    y1: 83.86,
    x2: 58.94,
    y2: 92.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 69.38,
    y1: 92,
    x2: 64.33,
    y2: 94.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 103.88,
    y1: 85.42,
    x2: 78.43,
    y2: 99.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 103.88,
    y1: 85.42,
    x2: 96.57,
    y2: 80.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 96.57,
    y1: 80.38,
    x2: 73.56,
    y2: 93.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 96.57,
    y1: 80.38,
    x2: 89.93,
    y2: 80.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 89.93,
    y1: 80.03,
    x2: 69.13,
    y2: 91.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 83.75,
    y1: 101.59,
    x2: 78.43,
    y2: 99.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 78.43,
    y1: 99.68,
    x2: 78.36,
    y2: 99.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 78.36,
    y1: 99.88,
    x2: 83.82,
    y2: 101.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 83.82,
    y1: 101.85,
    x2: 88.69,
    y2: 98.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 88.69,
    y1: 98.95,
    x2: 92.98,
    y2: 100.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 92.98,
    y1: 100.49,
    x2: 97.85,
    y2: 106.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 97.85,
    y1: 106.9,
    x2: 97.92,
    y2: 106.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 97.92,
    y1: 106.69,
    x2: 93.05,
    y2: 100.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 93.05,
    y1: 100.29,
    x2: 88.62,
    y2: 98.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 88.62,
    y1: 98.69,
    x2: 83.75,
    y2: 101.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 111.58,
    y1: 85.83,
    x2: 103.88,
    y2: 85.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 103.88,
    y1: 85.42,
    x2: 78.43,
    y2: 99.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 88.87,
    y1: 99.02,
    x2: 83.82,
    y2: 101.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 133.12,
    y1: 86.98,
    x2: 97.92,
    y2: 106.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 133.12,
    y1: 86.98,
    x2: 125.81,
    y2: 81.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 125.81,
    y1: 81.94,
    x2: 93.05,
    y2: 100.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 125.81,
    y1: 81.94,
    x2: 119.16,
    y2: 81.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 119.16,
    y1: 81.58,
    x2: 88.62,
    y2: 98.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 103.24,
    y1: 108.61,
    x2: 97.92,
    y2: 106.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 97.92,
    y1: 106.69,
    x2: 97.85,
    y2: 106.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 97.85,
    y1: 106.9,
    x2: 103.31,
    y2: 108.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 103.31,
    y1: 108.86,
    x2: 108.18,
    y2: 105.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 108.18,
    y1: 105.97,
    x2: 112.47,
    y2: 107.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 112.47,
    y1: 107.51,
    x2: 117.34,
    y2: 113.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 117.34,
    y1: 113.92,
    x2: 117.42,
    y2: 113.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 117.42,
    y1: 113.71,
    x2: 112.54,
    y2: 107.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 112.54,
    y1: 107.31,
    x2: 108.11,
    y2: 105.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 108.11,
    y1: 105.71,
    x2: 103.24,
    y2: 108.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 140.82,
    y1: 87.39,
    x2: 133.12,
    y2: 86.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 133.12,
    y1: 86.98,
    x2: 97.92,
    y2: 106.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 108.36,
    y1: 106.03,
    x2: 103.31,
    y2: 108.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 162.35,
    y1: 88.53,
    x2: 117.42,
    y2: 113.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 162.35,
    y1: 88.53,
    x2: 155.05,
    y2: 83.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 155.05,
    y1: 83.49,
    x2: 112.54,
    y2: 107.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 155.05,
    y1: 83.49,
    x2: 148.4,
    y2: 83.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 148.4,
    y1: 83.14,
    x2: 108.11,
    y2: 105.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 122.73,
    y1: 115.62,
    x2: 117.42,
    y2: 113.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 117.42,
    y1: 113.71,
    x2: 117.34,
    y2: 113.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 117.34,
    y1: 113.92,
    x2: 122.8,
    y2: 115.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 122.8,
    y1: 115.88,
    x2: 127.68,
    y2: 112.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 127.68,
    y1: 112.99,
    x2: 131.96,
    y2: 114.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 131.96,
    y1: 114.53,
    x2: 136.83,
    y2: 120.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 136.83,
    y1: 120.93,
    x2: 136.91,
    y2: 120.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 136.91,
    y1: 120.73,
    x2: 132.03,
    y2: 114.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 132.03,
    y1: 114.32,
    x2: 127.6,
    y2: 112.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 127.6,
    y1: 112.73,
    x2: 122.73,
    y2: 115.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 170.05,
    y1: 88.94,
    x2: 162.35,
    y2: 88.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 162.35,
    y1: 88.53,
    x2: 117.42,
    y2: 113.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 127.86,
    y1: 113.05,
    x2: 122.8,
    y2: 115.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 191.48,
    y1: 90.32,
    x2: 136.83,
    y2: 120.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 191.48,
    y1: 90.32,
    x2: 191.59,
    y2: 90.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 191.59,
    y1: 90.09,
    x2: 136.91,
    y2: 120.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 191.59,
    y1: 90.09,
    x2: 184.28,
    y2: 85.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 184.28,
    y1: 85.05,
    x2: 132.03,
    y2: 114.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 184.28,
    y1: 85.05,
    x2: 177.63,
    y2: 84.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 177.63,
    y1: 84.7,
    x2: 127.6,
    y2: 112.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 191.59,
    y1: 89.86,
    x2: 191.23,
    y2: 89.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 170.43,
    y1: 88.73,
    x2: 161.99,
    y2: 88.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 141.2,
    y1: 87.17,
    x2: 132.75,
    y2: 86.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 111.96,
    y1: 85.62,
    x2: 103.52,
    y2: 85.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 82.73,
    y1: 84.06,
    x2: 74.54,
    y2: 83.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 209.78,
    y1: 79.67,
    x2: 191.59,
    y2: 89.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 191.59,
    y1: 78.7,
    x2: 209.78,
    y2: 68.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 209.78,
    y1: 68.51,
    x2: 131.74,
    y2: 40.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 131.74,
    y1: 40.41,
    x2: 74.54,
    y2: 72.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 74.54,
    y1: 72.46,
    x2: 191.59,
    y2: 78.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 191.59,
    y1: 89.86,
    x2: 191.59,
    y2: 78.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 74.54,
    y1: 72.46,
    x2: 74.54,
    y2: 83.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 209.78,
    y1: 68.51,
    x2: 209.78,
    y2: 79.67
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 62.82,
    y1: 68.12,
    x2: 62.82,
    y2: 82.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 62.82,
    y1: 78.81,
    x2: 60.75,
    y2: 76.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 62.82,
    y1: 78.81,
    x2: 64.88,
    y2: 80.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 62.82,
    y1: 78.81,
    x2: 58.68,
    y2: 78.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 62.82,
    y1: 78.81,
    x2: 85.09,
    y2: 80
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 62.82,
    y1: 71.84,
    x2: 60.75,
    y2: 69.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 62.82,
    y1: 71.84,
    x2: 64.88,
    y2: 73.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 62.82,
    y1: 71.84,
    x2: 58.68,
    y2: 71.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 62.82,
    y1: 71.84,
    x2: 72.77,
    y2: 72.37
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.58 76.49 63.92 75.76 63.64 75.02 62.92 74.68 62.17 74.95 61.84 75.68 62.11 76.43 62.84 76.76 63.58 76.49"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "63.58 76.49 63.92 75.76 63.64 75.02 62.92 74.68 62.17 74.95 61.84 75.68 62.11 76.43 62.84 76.76 63.58 76.49"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "63.58 76.49 63.92 75.76 63.64 75.02 62.92 74.68 62.17 74.95 61.84 75.68 62.11 76.43 62.84 76.76 63.58 76.49"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 25.89,
    y1: 35.56,
    x2: 40.08,
    y2: 35.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 62.88,
    y1: 75.72,
    x2: 25.89,
    y2: 35.56
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(43.2 38.68)"
  }, "Fill Thickness"), /*#__PURE__*/React.createElement("polygon", {
    points: "142.06 52.89 142.85 53.01 143.49 52.54 143.61 51.75 143.14 51.11 142.35 50.99 141.71 51.46 141.59 52.25 142.06 52.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "142.06 52.89 142.85 53.01 143.49 52.54 143.61 51.75 143.14 51.11 142.35 50.99 141.71 51.46 141.59 52.25 142.06 52.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "142.06 52.89 142.85 53.01 143.49 52.54 143.61 51.75 143.14 51.11 142.35 50.99 141.71 51.46 141.59 52.25 142.06 52.89"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 152.56,
    y1: 35.56,
    x2: 161.12,
    y2: 35.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 142.6,
    y1: 52,
    x2: 152.56,
    y2: 35.56
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(164.24 38.68)"
  }, "Fill Material"), /*#__PURE__*/React.createElement("polygon", {
    points: "141.54 113.07 141.2 113.79 141.47 114.54 142.19 114.88 142.94 114.61 143.28 113.88 143.01 113.14 142.28 112.8 141.54 113.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "141.54 113.07 141.2 113.79 141.47 114.54 142.19 114.88 142.94 114.61 143.28 113.88 143.01 113.14 142.28 112.8 141.54 113.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "141.54 113.07 141.2 113.79 141.47 114.54 142.19 114.88 142.94 114.61 143.28 113.88 143.01 113.14 142.28 112.8 141.54 113.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 152.56,
    y1: 125.09,
    x2: 161.12,
    y2: 125.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 142.24,
    y1: 113.84,
    x2: 152.56,
    y2: 125.09
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(164.24 128.21)"
  }, "Metal Deck "), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(164.24 138.27)"
  }, "Profile Member"), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(24 168.54)"
  }, "Note: Fill thickness is specified as thickness above the "), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(24 178.6)"
  }, "top flute, however volume calculations include the "), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(24 188.67)"
  }, "volume of the filled flutes.")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMetalDeckLayer);
export default __webpack_public_path__ + "static/media/IconMetalDeckLayer.16dac4a3cabd562f9ac5e346b63a2269.svg";
export { ForwardRef as ReactComponent };